import {
  Box,
  Breadcrumbs,
  Button,
  Paper,
  Select,
  Text,
  TextInput,
  Textarea,
  Title,
  UnstyledButton,
  createStyles,
} from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import { Modal, Group } from "@mantine/core";

import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import calendarSvg from "../../assets/img/calendar.svg";
import { AppointmentModal } from "./AppointmentModal";
import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../store/types/appState";
import { epicHandler, filterByValueString, kaleyraHandler } from "../../utils";
import { Identifier } from "@medplum/fhirtypes";
import { showNotification } from "@mantine/notifications";
import { RedirectingModal } from "../../components/RedirectingModal";
import others from "../../assets/img/others.svg";
import EpicSelect from "../../assets/img/EpicPatint.svg";
import cernerSelecr from "../../assets/img/CernerPatient.svg";
import aaathenaSelect from "../../assets/img/AthenaPatient.svg";
import GenericInfoModal from "../../components/GenericInfoModal";
import fetchResourceIcon from "../../assets/img/fetchingResourceLogo.svg";
import dbStoringIcon from "../../assets/img/storingDBLogo.svg";
import { fetchPatientDetails } from "../ClinicalNotes/clinicalNotesService";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",

    padding: "16px",
    marginTop: "16px",
  },
  Box1: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title1: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  cancel: {
    color: "black",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  create: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
  descrption: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    marginBottom: "5px",
  },
  textarea: {
    height: "168px",
    width: "100%",
    padding: "16px",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    border: "1px solid #E5E5E5",
    outline: "none",
    resize: "none",
    borderRadius: "8px",
    wordBreak: "break-word",
  },
}));

export const NewAppointment = () => {
  const { classes } = useStyles();
  const {id} =useParams()

  const medplum = useMedplum();
  const profile = medplum.getProfile();
  const navigate = useNavigate();
  const [patientList, setPatientList] = useState<any>([]);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [medicationList, setMedicationList] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [isloading, setIsLoading] = useState<boolean>(false);
  const [selectedTime, setSelectedTime] = useState<any>("");
  const [selectedDate, setSelectedDate] = useState<any>("");
  const [appointmentNote, setAppointmentNote] = useState<any>("");
    const [showInfoModal, setShowModal] = useState(false);
    const[epicId,setEpicId]=useState<any>()
 const [modalData, setModalData] = useState({
   title: "",
   sideTitle: "",
   details: [] as any,
   confirmText: "",
   onClose: () => {},
   onConfirm: () => {},
 });

  useEffect(() => {
    // getPatientList();
    getEpicId()
  }, []);


  useEffect(() => {
    setIsFetching(true);
    setMedicationList([]);
    getMedications(selectedPatient);
  }, [selectedPatient]);
   const modalSteps = [
     {
       loadText: "Creating new appointment in EPIC EHR",
       label: "Creating new appointment in EPIC EHR",
       icon: fetchResourceIcon,
     },
     {
       loadText: "Appointment created successfully",
       label: "Appointment created successfully",
       icon: fetchResourceIcon,
     },
     {
       loadText: "Storing in HealthConnect",
       label: "Store in HealthConnect",
       icon: dbStoringIcon,
     },
   ];

   const getEpicId=()=>{
    fetchPatientDetails(medplum,id).then((res)=>{
      setEpicId(res)
    })
   }

  const getMedications = async (id: any) => {
    const medications = await medplum.searchResources(
      "MedicationRequest",
      "patient=" + id
    );
    setMedicationList(medications);
    setIsFetching(false);
  };
  const handleAppointmentConfirmation = (date: Date, time: string) => {
    const dateString = date.toISOString().substring(0, 10);

    setSelectedTime(time);
    setSelectedDate(dateString);
    close();
  };

  let storedAppointmentid = localStorage.getItem("appointmentResource");

  if (storedAppointmentid !== null) {
    if (
      storedAppointmentid.startsWith('"') &&
      storedAppointmentid.endsWith('"')
    ) {
      storedAppointmentid = storedAppointmentid.slice(1, -1);
    }
  }

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if ((res?.use === "official" || res?.use === "usual") && name === "--") {
          name = res?.text || res?.given[0];
        } 
      });
      if (name === "--") name = patientData[0]?.text || patientData[0]?.given || "--"
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  }

  function findValueBySystem(
    array: Identifier[],
    systemKey: string
  ): string | undefined {
    const matchingObject = array.find((obj: any) => obj.system === systemKey);
    return matchingObject ? matchingObject.value : undefined;
  }

const getPatientList = async () => {
  const res = await medplum.searchResources("Patient", "_count=500");

  const patientData = res
    .map((patient) => {
      let value;
      if (patient?.identifier) {
        value = findValueBySystem(
          patient.identifier,
          "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id"
        );
      }

      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item) => item.system && item.system.includes("athena")
      );

      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }

      // Filter for EPIC only
      if (ehrtype !== "EPIC") {
        return null;
      }

      const EHRIcon = (
        <img
          src={EpicSelect}
          style={{
            marginRight: "10px",
            width: "30px",
          }}
          alt="EPIC"
        />
      );

      return {
        label: getPatientName(patient.name),
        value: value ? value : patient.id,
        ehr: ehrtype,
        icon: EHRIcon,
      };
    })
    .filter((patient) => patient !== null) as {
    label: string;
    value: string | undefined;
    ehr: string;
    icon: JSX.Element;
  }[];

  if (patientData.length > 0) {
    setSelectedPatient(patientData[0].value);
  } else {
    setSelectedPatient(undefined); // Handle the case when no EPIC patients are found
  }

  setPatientList(patientData);
};

  const getselectedPatientEhrType = (id: string) => {
    // Assuming patientList is an array containing patient objects
    let selectedPatientss = patientList.find(
      (patient: any) => patient.value === id
    );
    if (selectedPatientss) {
      let ehrtypes = selectedPatientss.ehr;

      // Check the EHR type and return the appropriate image source
      if (ehrtypes === "EPIC") {
        return (
          <img
            src={EpicSelect}
            style={{
              marginRight: "10px",
              width: "30px",
              height: "30px",
            }}
            alt="Epic EHR"
          />
        );
      } else if (ehrtypes === "Cerner") {
        return (
          <img
            src={cernerSelecr}
            style={{
              marginRight: "20px",
              width: "150px",
            }}
            alt="Cerner"
          />
        );
      } else if (ehrtypes === "Athena Health") {
        return (
          <img
            src={aaathenaSelect}
            style={{
              marginRight: "10px",
              width: "30px",
            }}
            alt="Athena HEalth"
          />
        );
      } else if (ehrtypes === "Others") {
        return (
          <img
            src={others}
            style={{
              marginRight: "30px",
              width: "30px",
            }}
            alt="Others"
          />
        );
      } else {
        return "NA"; // or handle the case of unsupported EHR type accordingly
      }
    } else {
      return (
        <img
          src={others}
          style={{
            marginRight: "30px",
            width: "30px",
          }}
          alt="Others"
        />
      );
    }
  };
  const logginedUser = useSelector((state: AppState) => state) as any;
  const statuss: any[] = logginedUser?.app?.profile?.extension || [];
  const token = statuss.map((item) => {
    const accessTokenObj = item.extension.find(
      (ext: any) => ext.url === "access_token"
    );
    return accessTokenObj ? accessTokenObj.valueString : null;
  });
  const getSelectedPaitentName = (id: string) => {
    let res = patientList.filter((patient: any) => {
      return patient.value === id;
    });
    return res[0].label;
  };

  const bookAppointment = async () => {
    setIsLoading(true);
    const epicDataFromExtension = filterByValueString(
      logginedUser?.app?.profile?.extension || ([] as any),
      "epic"
    );
    try {
      const appointmentPayload = {
        eventType: "bookAppointment",
        accessToken:
          epicDataFromExtension[epicDataFromExtension?.length - 1]
            ?.extension?.[0]?.valueString || "",
        patientId: epicId,
        appointmentId: storedAppointmentid,
        appointmentNote: appointmentNote,
      };
      let appointmentRes;
      try {
        appointmentRes = await epicHandler(medplum, appointmentPayload);
      } catch (err) {
        setIsLoading(true);
        setShowModal(false);
      }

      if (appointmentRes.status === 201) {
        const createRoomPayload = {
          type: "create_room",
          participants: [
            {
              user_id: `${profile?.id}__${appointmentRes?.body?.id}`,
              is_admin: true,
            },
            {
              user_id: `${epicId}__${appointmentRes?.body?.id}`,
            },
          ],
        };
       

        const res = await kaleyraHandler(medplum, createRoomPayload);

        const storeMeetingLinks = {
          url: `https://stage.ehrconnect.healthconnect.systems`,
          extension: [
            {
              url: res.body?.participants?.[0]?.url,
              valueString: res.body?.participants?.[0]?.user_id,
            },
            {
              url: res.body?.participants?.[1]?.url,
              valueString: res.body?.participants?.[1]?.user_id,
            },
          ],
        };

        const newIdentifier = [
          {
            system: "epic_appointment_id",
            value: appointmentRes?.body?.id,
          },
        ];

        const mutableAppointment = { ...appointmentRes?.body };
        mutableAppointment.extension = Array.isArray(
          mutableAppointment.extension
        )
          ? [...mutableAppointment.extension]
          : [];
        mutableAppointment.extension.push(storeMeetingLinks as any);
        mutableAppointment.identifier = [
          ...mutableAppointment?.identifier,
          ...newIdentifier,
        ];

        await medplum.createResource(mutableAppointment);
        setIsLoading(false);

       
      } else {
        showNotification({
          color: "red",
          message: "Failed to book Appointment!",
          autoClose: true,
        });

        setShowModal(false);
        setIsLoading(false);
        return
      }
    } catch (error) {
      setShowModal(false);
      setIsLoading(false);
    }
  };

  const createAppointment=async()=>{
    try{
       setShowModal(true); 
      setModalData({
        title: "Please wait, we are creating New Appointment",
        sideTitle: "",
        details: [
          { label: "", text: ""},
          { label: "", text: "" },

        ],
        confirmText: "Proceed",
        onClose: () => setShowModal(false),
        onConfirm: async () => {
          await bookAppointment()
            setTimeout(() => {
                      navigate(`/patient/details/${id}`);
                       showNotification({
                         color: "green",
                         message: "success",
                         autoClose: true,
                       });

            }, 1000);
          
        }})

    }catch(error){
      console.error(error)
    }
  }


  const handleAppointmentNoteChange = (e: any) => {
    setAppointmentNote(e.target.value);
  };
  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: any;
    ehr: string;
    icon: any;
  }
  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group
          noWrap
          sx={{
            justifyContent: "space-between",
            height: "30px",
            width: "100%",
          }}
        >
          <div>
            <Text>{label}</Text>
          </div>
          <div>{icon}</div>
        </Group>
      </div>
    )
  );

  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      {/* <RedirectingModal
        isOpen={isloading}
        onClose={() => setIsLoading(false)}
        vendor={"Epic"}
        text={"Creating Appointment..."}
      /> */}
      <Modal opened={opened} onClose={close} withCloseButton={false} size="69%">
        <AppointmentModal
          cancel={close}
          onAppointmentConfirmed={handleAppointmentConfirmation}
        />
      </Modal>
      <Paper className={classes.default}>
        <Box sx={{}}>
          <Box className={classes.Box1}>
            <Box>
              <CustomBreadcrumbs />
            </Box>
            <Box>
              <Title className={classes.title1}>New appointment</Title>
            </Box>
            <Box>
              {/* <Select
                label="Select patient"
                placeholder="Loading..."
                required={true}
                data={patientList}
                mt="lg"
                size="lg"
                radius="md"
                value={selectedPatient}
                onChange={(val) => {
                  setSelectedPatient(val);
                }}
                rightSection={getselectedPatientEhrType(selectedPatient)}
                sx={{
                  ".mantine-Select-itemsWrapper": {
                    paddingRight: "10px",
                  },
                }}
                searchable
                itemComponent={SelectItem}
              /> */}

              <TextInput
                label="Date and time"
                placeholder={
                  selectedDate && selectedTime
                    ? undefined
                    : "Select date and time"
                }
                value={
                  selectedDate && selectedTime
                    ? selectedDate + " " + selectedTime
                    : ""
                }
                onClick={open}
                required={true}
                mt="lg"
                size="lg"
                radius="md"
                rightSection={
                  <img
                    src={calendarSvg}
                    style={{
                      width: 20,
                      height: 20,
                      color: "#666",
                      cursor: "pointer",
                    }}
                    onClick={open}
                  />
                }
                sx={{
                  ".mantine-Select-itemsWrapper": {
                    paddingRight: "10px",
                  },
                }}
              />
              <Textarea
                label="Appointment notes"
                placeholder="Add appointment notes"
                value={appointmentNote}
                onChange={handleAppointmentNoteChange}
                required={true}
                mt="lg"
                size="lg"
                radius="md"
                minRows={5}
                maxRows={5}
                sx={{
                  ".mantine-Select-itemsWrapper": {
                    paddingRight: "10px",
                  },
                }}
              />
            </Box>
            {/* <Box>
                <Text className={classes.descrption}>
                  Description <span style={{ color: "red" }}>*</span>
                </Text>
                <Box
                  sx={{
                    height: "168px",
                    borderRadius: "5px",
                  }}
                >
                  <textarea
                    placeholder="Notes Description"
                    className={classes.textarea}
                    // value={description}
                    // onChange={(e) => setDescription(e.target.value)}
                  />
                </Box>
              </Box> */}

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "16px",
              }}
            >
              <Button
                variant="outline"
                className={classes.cancel}
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                className={classes.create}
                onClick={createAppointment}
                disabled={
                  // !selectedPatient ||
                  !selectedDate ||
                  !selectedTime ||
                  !appointmentNote
                }
              >
                Create
              </Button>
            </Box>
          </Box>
        </Box>
        {showInfoModal && (
          <GenericInfoModal
            isOpen={showInfoModal}
            steps={modalSteps}
            modalData={modalData}
            onClose={modalData.onClose}
            onConfirm={modalData.onConfirm}
            setIsPatientModalOpen={setShowModal}
            showStepsImmediately={true}
            autoConfirm={true}
          />
        )}
      </Paper>
    </>
  );
};
